import searchIcon from "../assets/images/Search.png";
import recent from "../assets/images/recent.svg";
import cross from "../assets/images/cross-black.svg";
import "./searchin.css"
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card } from "semantic-ui-react";
import { useNavigate } from "react-router";
import { update } from "lodash";

import { useSelector, useDispatch } from 'react-redux'
import { updateDestination } from "../redux/features/tripFormSlice";
import { ref } from "yup";

const recentSearch = [
  {
  "id": 1,
  "name": "Bali",
  "username": "Bret",
  "email": "Sincere@april.biz",
  "address": {
      "street": "Kulas Light",
      "suite": "Apt. 556",
      "city": "Gwenborough",
      "zipcode": "92998-3874",
      "geo": {
          "lat": "-37.3159",
          "lng": "81.1496"
      }
  },
  "phone": "1-770-736-8031 x56442",
  "website": "hildegard.org",
  "company": {
      "name": "Romaguera-Crona",
      "catchPhrase": "Multi-layered client-server neural-net",
      "bs": "harness real-time e-markets"
  },},
  {
    "id": 2,
    "name": "Maldives",
    "username": "Bret",
    "email": "Sincere@april.biz",
    "address": {
        "street": "Kulas Light",
        "suite": "Apt. 556",
        "city": "Gwenborough",
        "zipcode": "92998-3874",
        "geo": {
            "lat": "-37.3159",
            "lng": "81.1496"
        }
    },
    "phone": "1-770-736-8031 x56442",
    "website": "hildegard.org",
    "company": {
        "name": "Romaguera-Crona",
        "catchPhrase": "Multi-layered client-server neural-net",
        "bs": "harness real-time e-markets"
    },

  }, {
    "id": 3,
  "name": "Cape Town",
  "username": "Bret",
  "email": "Sincere@april.biz",
  "address": {
      "street": "Kulas Light",
      "suite": "Apt. 556",
      "city": "Gwenborough",
      "zipcode": "92998-3874",
      "geo": {
          "lat": "-37.3159",
          "lng": "81.1496"
      }
  },
  "phone": "1-770-736-8031 x56442",
  "website": "hildegard.org",
  "company": {
      "name": "Romaguera-Crona",
      "catchPhrase": "Multi-layered client-server neural-net",
      "bs": "harness real-time e-markets"
  }
}
 
  ]

export default function Searchin() {
  const [APIData, setAPIData] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    axios.get(`https://jsonplaceholder.typicode.com/users`).then((response) => {
      console.log(response.data, 'json data')
      setAPIData(response.data);
    });
  }, []);

  const searchItems = (searchValue) => {
    if (searchInput !== "") {
      const filteredData = APIData.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchInput.toLowerCase());
      });
      console.log(filteredData, 'filteredData');
      setFilteredResults(filteredData);
    } else {
      setFilteredResults(APIData);
    }
    setSearchInput(searchValue);
  };

  const handleCancel = () => {
    setSearchInput("")
  }

  const updateLocation = (destination)=> {
    dispatch(updateDestination(destination.name))
    navigate(-1)
  }
  return (
    // <div className="search-page">
    //       <div className="search">
    //            <div className="serch-input-country">
    //               <img style={{paddingLeft: "16px"}} src={searchIcon} alt="search" />
    //                  <input
    //                     className="search-inp"
    //                     type="text"
    //                     placeholder="where are you going"
    //                     onChange={(e) => searchItems(e.target.value)}
    //                  />
    //            </div>
    //               <p className="s-label">Cancel</p>
    <>
       
      <div className="search-page">
      <div className="cross-mark" onClick={() => navigate(-1)}>
        <img src={cross} alt="cross" />
      </div>
        <div className="search">
          <div className="serch-input">
            <img style={{ paddingLeft: "16px" }} src={searchIcon} alt="search" />
            <input
              className="search-inp"
              type="text"
              placeholder="where are you going"
              value={searchInput}
              onChange={(e) => searchItems(e.target.value)}
  
            />
          </div>
          <button className="s-label" onClick={handleCancel}>Cancel</button>
        </div>
        <div className="recent-searches">
          <div className="search"
          >
            Recent searches
          </div>

          <p>
            {

              searchInput.length == 0 ?

                <div className="searched-content">

                  {recentSearch.map (recentItem => {
                    return(
                      <div className="search-content" onClick={()=> {updateLocation(recentItem)}}>
                      <img src={recent} alt="recent" />
                      <p className="location">{recentItem.name}</p>
                    </div>
                    );
                  })}
                 
                </div>
                : null

            }
          </p>

        </div>

        <Card.Group itemsPerRow={3} style={{ marginTop: 20 }}>
          {searchInput.length > 1
            ? filteredResults.map((item) => {
              return (
                <Card>
                  <Card.Content>
                    <Card.Header>{item.name}</Card.Header>
                    <Card.Description>{item.email}</Card.Description>
                  </Card.Content>
                </Card>
              );
            })
            : null
            // APIData.map((item) => {
            //     return (
            //       <Card>
            //         <Card.Content>
            //           <Card.Header>{item.name}</Card.Header>
            //           <Card.Description>{item.email}</Card.Description>
            //         </Card.Content>
            //       </Card>
            //     );
            //   }
            //   )
          }
        </Card.Group>
      </div>
    </>
 );
}
